export var VERSION = '2.3.3';
//# sourceMappingURL=version.js.map